import React, { FC, useMemo } from 'react';

import { Tag } from '@brg/api';
import { useTheme } from "styled-components";
import { FlexBox, MagicBox, TagCategoryItem, useBreakpoint } from "@brg/ui";
import ICArrowRight32 from "../../assets/32/ICArrowRightLarge32";
import { LayoutConst, bTag } from "../../../core";
import { TagsSearchResultsTitle } from "./styles.mobile";
import { TagItemViewTextWrapper } from "../../../core/components/bTag/styles";
import { ArrowCornerSvg } from "../../assets/24/ArrowCornerSvg";
import { useDispatch, useSelector } from "react-redux";
import { TagsActions } from "../../reducers/Tags";

const DELAY_FOR_FETCH_TAGS = 100;

export interface CategoryTagItemProps {
  tag: any;
  onSelect?: (tag: Tag) => void;
  selected?: boolean;
  isHoverMode?: boolean;
  isActive?: boolean;
  disableHover?: boolean;
  onMouseEnter?: (ev: any,tagId: string) => void;
}

const CategoryTagItem: FC<CategoryTagItemProps> = ({
  tag,
  onSelect,
  selected,
  isHoverMode,
  isActive,
  disableHover,
  onMouseEnter,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const headerTag = useSelector((state: any) => state.tags.headerTag);
  const isEditProjectPage = window.location.pathname.startsWith('/edit');
  const is744 = useBreakpoint(LayoutConst.screen.s);

  const handleArrowClick = () => {
    dispatch(TagsActions.setHeaderTag({
      current: tag,
      parent: headerTag.current,
    }));
    dispatch(TagsActions.setSearchText(''));
  }

  const handleTitleClick = () => {
    onSelect?.(tag);
  }

  const title = bTag.title(tag);

  const shouldVisibleArrowSvg = false
  // const shouldVisibleArrowSvg = useMemo(() => (tag?.level !== 1 && !isHoverMode), [tag, isHoverMode])

  return (
      <TagCategoryItem
          disableHover={disableHover}
          active={isActive || selected}
          data-id={tag?.tagId}
          onMouseOver={(ev: any) => onMouseEnter && onMouseEnter(ev, tag?.tagId)}
      >
        <FlexBox justify="space-between" align="center" data-id={tag?.tagId} width="100%">
          <MagicBox onClick={handleTitleClick} widthMobile={'max-content'}>
            {tag.level === 1 && (
                <TagItemViewTextWrapper
                    parent
                    selected={selected}
                    isProjectsTag
                >
                  {title}
                </TagItemViewTextWrapper>
            )}
            {tag.level === 2 && (
                <TagsSearchResultsTitle data-id={tag?.tagId}>
                  {title}
                </TagsSearchResultsTitle>
            )}
            {!isEditProjectPage && shouldVisibleArrowSvg && (
                <MagicBox offsetLeft={is744 ? 0 : 4} align={'center'}>
                  <ArrowCornerSvg clr={theme.tagSearch.arrowColor} opacity={'1'}/>
                </MagicBox>
            )}
          </MagicBox>
        </FlexBox>
        {!isHoverMode && (
            <MagicBox widthMobile={'100%'} justifyMobile='flex-end' offsetLeft={4} align={'center'} onClick={handleArrowClick}>
              <ICArrowRight32 fill={theme.tags.modal.search.color}/>
            </MagicBox>
        )}
      </TagCategoryItem>
  );
};

export default React.memo(CategoryTagItem)import React, { FC, useMemo } from 'react';

import { Tag } from '@brg/api';
import { useTheme } from "styled-components";
import { FlexBox, MagicBox, TagCategoryItem, useBreakpoint } from "@brg/ui";
import ICArrowRight32 from "../../assets/32/ICArrowRightLarge32";
import { LayoutConst, bTag } from "../../../core";
import { TagsSearchResultsTitle } from "./styles.mobile";
import { TagItemViewTextWrapper } from "../../../core/components/bTag/styles";
import { ArrowCornerSvg } from "../../assets/24/ArrowCornerSvg";
import { useDispatch, useSelector } from "react-redux";
import { TagsActions } from "../../reducers/Tags";

const DELAY_FOR_FETCH_TAGS = 100;

export interface CategoryTagItemProps {
  tag: any;
  onSelect?: (tag: Tag) => void;
  selected?: boolean;
  isHoverMode?: boolean;
  isActive?: boolean;
  disableHover?: boolean;
  onMouseEnter?: (ev: any,tagId: string) => void;
}

const CategoryTagItem: FC<CategoryTagItemProps> = ({
  tag,
  onSelect,
  selected,
  isHoverMode,
  isActive,
  disableHover,
  onMouseEnter,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const headerTag = useSelector((state: any) => state.tags.headerTag);
  const isEditProjectPage = window.location.pathname.startsWith('/edit');
  const is744 = useBreakpoint(LayoutConst.screen.s);

  const handleArrowClick = () => {
    dispatch(TagsActions.setHeaderTag({
      current: tag,
      parent: headerTag.current,
    }));
    dispatch(TagsActions.setSearchText(''));
  }

  const handleTitleClick = () => {
    onSelect?.(tag);
  }

  const title = bTag.title(tag);

  const shouldVisibleArrowSvg = false
  // const shouldVisibleArrowSvg = useMemo(() => (tag?.level !== 1 && !isHoverMode), [tag, isHoverMode])

  return (
      <TagCategoryItem
          disableHover={disableHover}
          active={isActive || selected}
          data-id={tag?.tagId}
          onMouseOver={(ev: any) => onMouseEnter && onMouseEnter(ev, tag?.tagId)}
      >
        <FlexBox justify="space-between" align="center" data-id={tag?.tagId} width="100%">
          <MagicBox onClick={handleTitleClick} widthMobile={'max-content'}>
            {tag.level === 1 && (
                <TagItemViewTextWrapper
                    parent
                    selected={selected}
                    isProjectsTag
                >
                  {title}
                </TagItemViewTextWrapper>
            )}
            {tag.level === 2 && (
                <TagsSearchResultsTitle data-id={tag?.tagId}>
                  {title}
                </TagsSearchResultsTitle>
            )}
            {!isEditProjectPage && shouldVisibleArrowSvg && (
                <MagicBox offsetLeft={is744 ? 0 : 4} align={'center'}>
                  <ArrowCornerSvg clr={theme.tagSearch.arrowColor} opacity={'1'}/>
                </MagicBox>
            )}
          </MagicBox>
        </FlexBox>
        {!isHoverMode && (
            <MagicBox widthMobile={'100%'} justifyMobile='flex-end' offsetLeft={4} align={'center'} onClick={handleArrowClick}>
              <ICArrowRight32 fill={theme.tags.modal.search.color}/>
            </MagicBox>
        )}
      </TagCategoryItem>
  );
};

export default React.memo(CategoryTagItem)